import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'modal-termo.component',
    templateUrl: './modal-termo.component.html',
    styleUrls: ['./modal-termo.component.css']
  })
  export class ModalTermoComponent implements OnInit  {

    @ViewChild('termo', { static: true }) myDiv: ElementRef;

       constructor(     
      public dialogRef: MatDialogRef<ModalTermoComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    innerHtml: string;

    ngOnInit() {     
      this.innerHtml = this.data.termo;
  }
  
  
    onClose() {
        this.dialogRef.close();
    }

   
}

